module.exports = __webpack_public_path__ + "img/按钮5.046c4819.png";